import { useEffect } from "react";

/**
 * Sets .sidebar-right padding-bottom to match a fixed sticky footer height
 * so content stays scrollable when the bar grows (e.g. validation errors).
 * @param {React.RefObject<HTMLElement>} footerRef Ref on the sticky footer element
 */
function useStickyFooterScrollPadding(footerRef) {
  useEffect(() => {
    const footerElement = footerRef.current;
    if (!footerElement) {
      return undefined;
    }

    const scrollParent =
      footerElement.closest(".sidebar-right") || document.body;

    const syncPadding = () => {
      scrollParent.style.setProperty(
        "padding-bottom",
        `${footerElement.offsetHeight}px`,
        "important"
      );
    };

    syncPadding();

    if (typeof ResizeObserver === "undefined") {
      return () => {
        scrollParent.style.removeProperty("padding-bottom");
      };
    }

    const resizeObserver = new ResizeObserver(syncPadding);
    resizeObserver.observe(footerElement);

    return () => {
      resizeObserver.disconnect();
      scrollParent.style.removeProperty("padding-bottom");
    };
  }, [footerRef]);
}

export default useStickyFooterScrollPadding;
